import { jsx as t } from "react/jsx-runtime";
import d from "clsx";
import n from "./Spacer.module.css.js";
const g = ({
  children: s,
  vertical: a = 0,
  horizontal: p = 0,
  top: o = a,
  right: i = p,
  bottom: r = a,
  left: c = p,
  className: e,
  ...l
}) => /* @__PURE__ */ t(
  "div",
  {
    className: d(n.container, e),
    style: {
      "--louis-spacer-padding-top": `var(--lok-spacing-${o})`,
      "--louis-spacer-padding-right": `var(--lok-spacing-${i})`,
      "--louis-spacer-padding-bottom": `var(--lok-spacing-${r})`,
      "--louis-spacer-padding-left": `var(--lok-spacing-${c})`
    },
    ...l,
    children: s
  }
);
g.displayName = "Spacer";
export {
  g as Spacer
};
//# sourceMappingURL=Spacer.js.map
